import { SeoPageLayout } from "@/components/SeoPageLayout";
import { SeoSection } from "@/components/seo/SeoSection";
import { SeoStyledList } from "@/components/seo/SeoStyledList";
import { SeoHighlightBox } from "@/components/seo/SeoHighlightBox";
import { Sun } from "lucide-react";

const KomikNaPiknik = () => (
  <SeoPageLayout title="Komik na" titleAccent="piknik firmowy">
    <SeoSection title="Stand-up na pikniku firmowym">
      <p>Piknik firmowy to jedno z najpopularniejszych wydarzeń integracyjnych w Polsce, szczególnie w sezonie wiosenno-letnim. Profesjonalny komik na pikniku firmowym to atrakcja, która angażuje wszystkich uczestników - od stażystów po zarząd. Występ komediowy na świeżym powietrzu, w luźnej atmosferze grilla i zabaw, tworzy wyjątkowy klimat, który łączy ludzi i buduje relacje w zespole.</p>
    </SeoSection>

    <SeoSection title="Jak wygląda występ na pikniku?">
      <SeoStyledList items={[
        "Scena plenerowa z profesjonalnym nagłośnieniem",
        "Występ 20-40 minut dopasowany do programu pikniku",
        "Humor family-friendly - odpowiedni dla wydarzeń z rodzinami",
        "Interakcja z publicznością i nawiązania do firmy",
        "Możliwość prowadzenia konkursów i zabaw",
        "Elastyczny format - od stand-upu po konferansjerkę całego pikniku"
      ]} />
    </SeoSection>

    <SeoSection title="Piknik z rodziną czy tylko dla pracowników?">
      <p>Nasi komicy potrafią dopasować materiał do obu formatów. Jeśli piknik jest z rodzinami i dziećmi, humor jest lekki, pozytywny i uniwersalny. Jeśli to event wyłącznie dla pracowników, materiał może być bardziej odważny i nawiązywać do wewnętrznych żartów firmowych. Zawsze ustalamy z organizatorem granice humoru przed występem.</p>
      <SeoHighlightBox icon={Sun}>
        Piknik z rodzinami? Bez obaw - nasi komicy mają bogaty repertuar family-friendly, który bawi dorosłych i nie nudzi dzieci.
      </SeoHighlightBox>
    </SeoSection>

    <SeoSection title="Zamów komika na piknik firmowy">
      <p>Zaplanuj piknik firmowy z niespodzianką! Skontaktuj się z nami i opisz swoje wydarzenie - lokalizacja, liczba uczestników, charakter pikniku. Zaproponujemy format komediowy, który idealnie wpasuje się w atmosferę Twojego pikniku.</p>
    </SeoSection>
  </SeoPageLayout>
);

export default KomikNaPiknik;
